<template>
  <span v-if="!hasOutcome(page)">
    <span v-if="daysUntilOutcome(page) > 0" class="text-muted">
      Running ({{daysUntilOutcome(page)}} days left)
    </span>
    <b-badge v-else-if="daysUntilOutcome(page) < 0">
      Inconclusive
    </b-badge>
  </span>
  <b-badge v-else-if="isWinner(page) === true" variant="success">
    <b-icon-check-circle />&nbsp; Winner
  </b-badge>
  <b-badge v-else-if="isWinner(page) === false" variant="danger">
    <b-icon-x-circle />&nbsp; Loser
  </b-badge>
  <b-badge v-else>
    Inconclusive
  </b-badge>
</template>
<script>
import Delta from '@/components/Delta'

export default {
  name: 'ResultBadge',
  components: { },
  props: ['page'],
  created() {
    if(this.hasOutcome(this.page)) {
      this.$emit('input', this.isWinner(this.page))
    }
  },
  methods: Object.assign(Delta.methods, {
    isWinner(page) {
      return page.experiment.delta > 0.05 ? true : page.experiment.delta <  0.05 ? false : null
    },
  })
}
</script>
